import { useMemo } from 'react';
import { convertUnitToMeters } from '~/_shared/utils/unitSystem/unitSystem.helpers';
import { convertPlacesSearchToBoundingBox } from '~/places/places.helpers';
import { PlacesSearchResultsRankingPreference } from '~/places/places.repository';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import { PlacesSearchCircleOverlayContainer } from './placesSearchCircleOverlay.container';
import { PlacesSearchRectangleOverlayContainer } from './placesSearchRectangleOverlay.container';

export const PlacesSearchOverlayContainer = ({
  searchId,
}: {
  searchId: PlacesSearchId;
}) => {
  const placesSearches = useMapSettingsPlacesSearchesSelector();

  const placesSearch = searchId ? placesSearches.find((search) => search.id === searchId) : null;

  const boundingBox = useMemo(() => {
    if (!placesSearch || placesSearch.preference === PlacesSearchResultsRankingPreference.Distance) {
      return null;
    }

    return convertPlacesSearchToBoundingBox(placesSearch);
  }, [placesSearch]);

  if (!placesSearch) {
    return null;
  }

  if (placesSearch.preference === PlacesSearchResultsRankingPreference.Distance) {
    return (
      <PlacesSearchCircleOverlayContainer
        center={placesSearch.center.latLng}
        radius={convertUnitToMeters(placesSearch.distance.value, placesSearch.distance.unit)}
        color={placesSearch.color}
      />
    );
  }

  if (!boundingBox) {
    return null;
  }

  return (
    <PlacesSearchRectangleOverlayContainer
      boundingBox={boundingBox}
      color={placesSearch.color}
    />
  );
};
